import React from 'react'

const ExtensionCalls = () => {
  return (
    <div>ExtensionCalls</div>
  )
}

export default ExtensionCalls